import { Routes, Route } from "react-router-dom";
import { useState } from "react";

// components
import Home from "./component/Home";
import NotFoundPage from "./component/NotFoundPage";
import Introduction from "./component/Introduction";
import Board from "./component/Board";
import Write from "./component/write";
import Detail from "./component/Detail";
import Login from "./component/Login";
import NoPermission from "./component/NoPermission";
import { useEffect } from "react";

// Context
import LocaleContext from "./context/localeContext.js";
import { apiUrl } from "./config/api";

// App
function App() {
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    fetch(apiUrl("/api/islogined"), { credentials: "include" })
      .then((res) => res.text())
      .then((data) => {
        try {
          setIsAuthorized(JSON.parse(data).ok);
        } catch (e) {
          // If server returned HTML (e.g. index.html) or invalid JSON, treat as not authorized
          console.warn("Failed to parse /api/islogined response:", e);
          setIsAuthorized(false);
        }
      })
      .catch((err) => {
        console.warn("islogined fetch failed:", err);
        setIsAuthorized(false);
      });
  }, []);

  return (
    <>
      <LocaleContext.Provider value={isAuthorized}>
        <Routes>
          {isAuthorized ? (
            <>
              <Route path="/write/:category" element={<Write></Write>}></Route>
              <Route
                path="/update/:category/:id"
                element={<Write isUpdate={true}></Write>}
              ></Route>
            </>
          ) : (
            <>
              <Route path="/login" element={<Login></Login>}></Route>
              <Route
                path="/write/:category"
                element={<NoPermission></NoPermission>}
              ></Route>
              <Route
                path="/update/:category/:id"
                element={<NoPermission></NoPermission>}
              ></Route>
            </>
          )}
          <Route path="/" element={<Home />}></Route>
          <Route path="/introduction" element={<Introduction />}></Route>
          <Route path="/board/:category" element={<Board />}></Route>
          <Route
            path="/detail/:category/:id"
            element={<Detail isAuthorized={isAuthorized}></Detail>}
          ></Route>
          <Route path="*" element={<NotFoundPage />}></Route>
        </Routes>
      </LocaleContext.Provider>
    </>
  );
}
export default App;
